import styled from 'styled-components'

type SectionTitleProps = {
  left?: boolean
}

const SectionTitle = styled.h4<SectionTitleProps>`
  ${(props) => props.theme.typography.h4}

  color: ${(props) => (props.color ? props.color : props.theme.color.primary)};
  margin: 0 0 20px;
  text-align: ${(props) => (props.left ? 'left' : 'center')};

  @media (max-width: ${(props) => props.theme.screen.sm}) {
    ${(props) => props.theme.typography.h6}

    text-align: left;
  }
`

export default SectionTitle
